<script setup lang="ts">
import { ref } from "vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import { useCustomizerStore } from "~~/modules/nuxt3-module-admin-doyac/stores/customizer";
import { message, notification, profile } from "../verticalHeader/data";

library.add(faSearch)

const customizer = useCustomizerStore();
const showSearch = ref(false);
const href = ref(undefined);
const messages = ref(message);
const notifications = ref(notification);
const userprofile = ref(profile);
function searchbox() {
  showSearch.value = !showSearch.value;
}
</script>

<template>
  <v-app-bar :color="customizer.darktheme ? '' : customizer.navbarColor" elevation="0" :class="[
    'horizontaTopbar',
    customizer.navbarColor == '#ffffff' ? '' : 'text-white',
  ]">
    <!-- ---------------------------------------------- -->
    <!---Logo part -->
    <!-- ---------------------------------------------- -->
    <div class="pa-4 d-none d-md-block">
      <LcFullLogoDark v-if="!customizer.darktheme && customizer.navbarColor == '#ffffff'" />
      <LcFullLogoLight v-else />
    </div>

    <v-app-bar-nav-icon :color="inherit" class="hidden-md-and-up" @click.stop="customizer.SET_SIDEBAR_DRAWER" />
    <!-- ---------------------------------------------- -->
    <!---Search part -->
    <!-- ---------------------------------------------- -->

    <v-btn text icon color="lighten-2" @click="searchbox">
      <v-icon icon="fa:far fa-search"></v-icon>
    </v-btn>
    <v-sheet v-if="showSearch" class="searchinput pa-2" elevation="10">
      <v-text-field color="success" label="Search" placeholder="Search Now" variant="outlined" append-icon="mdi-close"
        density="compact" hide-details @click:append="searchbox"></v-text-field>
    </v-sheet>
    <!---/Search part -->

    <v-spacer />
    <!-- ---------------------------------------------- -->
    <!---right part -->
    <!-- ---------------------------------------------- -->

    <!-- ---------------------------------------------- -->
    <!-- Messages -->
    <!-- ---------------------------------------------- -->
    <div class="d-flex">
      <v-btn icon class="ms-3" color="lighten-2">
        <v-badge color="error" dot>
          <v-icon>mdi-message</v-icon>
        </v-badge>

        <v-menu activator="parent" anchor="bottom end" origin="auto" max-width="300">
          <v-list class="pa-5" elevation="10" rounded="lg">
            <h4 class="d-flex">
              Messages
              <v-chip label small color="secondary" class="ml-auto">
                5 new
              </v-chip>
            </h4>

            <v-list-item v-for="(item, i) in messages" class="my-2 pa-3" :key="i" rounded="lg" :value="item"
              @click="href" :title="item.title" :subtitle="item.desc">
              <template v-slot:prepend>
                <v-list-item-avatar start class="v-list-item-avatar--start">
                  <v-avatar size="50">
                    <v-img :src="`/images/users/${item.image}`" :alt="item.image"
                      width="50"></v-img></v-avatar></v-list-item-avatar>
              </template>
            </v-list-item>
            <v-btn flat color="primary" class="mt-4" variant="tonal" block>See all Messages</v-btn>
          </v-list>
        </v-menu>
      </v-btn>

      <!-- ---------------------------------------------- -->
      <!-- Notification -->
      <!-- ---------------------------------------------- -->
      <v-btn icon class="ms-3" color="lighten-2">
        <v-badge color="error" dot>
          <v-icon>mdi-bell</v-icon>
        </v-badge>

        <v-menu activator="parent" max-width="300">
          <v-list class="pa-6" elevation="10" rounded="lg">
            <h4 class="d-flex">
              Notifications
              <v-chip class="ml-auto" label small color="error"> 5 new </v-chip>
            </h4>
            <v-list-item class="pa-3 mt-2" v-for="(item, i) in notifications" :key="i" :value="item" @click="href"
              rounded="lg" :title="item.title" :subtitle="item.desc">
              <template v-slot:prepend>
                <v-list-item-avatar start>
                  <v-btn :color="item.color" icon variant="tonal" elevation="0" class="mr-3">
                    <vue-feather :type="item.icon" size="18"></vue-feather>
                  </v-btn>
                </v-list-item-avatar>
              </template>
            </v-list-item>
            <v-btn block variant="elevated" color="secondary" class="mt-4 py-4">See all Notifications</v-btn>
          </v-list>
        </v-menu>
      </v-btn>
      <!-- ---------------------------------------------- -->
      <!-- Notification -->
      <!-- ---------------------------------------------- -->

      <!-- ---------------------------------------------- -->
      <!-- User Profile -->
      <!-- ---------------------------------------------- -->
      <v-btn icon class="ms-3">
        <v-avatar size="35">
          <!-- <img src="/images/users/user2.jpg" width="35" alt="Julia" /> -->
        </v-avatar>

        <v-menu activator="parent">
          <v-list class="pa-6" elevation="10" rounded="lg">
            <h4 class="font-weight-medium fs-18">User Profile</h4>
            <div class="d-flex align-center my-4">
              <div class="ml-4">
                <h4 class="font-weight-medium fs-18">Julia Roberts</h4>
                <span class="subtitle-2 font-weight-light">Administrator</span>
                <div class="d-flex align-center">
                  <vue-feather type="mail" size="16" class="d-flex grey--text"></vue-feather>
                  <span class="subtitle-2 font-weight-light ml-1">info@flexy.com</span>
                </div>
              </div>
            </div>
            <v-list-item class="pa-3 mb-2" v-for="(item, index) in userprofile" :key="index" :value="index"
              :title="item.title" :subtitle="item.desc">
              <template v-slot:prepend>
                <v-list-item-avatar start>
                  <v-btn :color="item.color" variant="tonal" icon elevation="0" class="mr-3">
                    <vue-feather :type="item.icon" size="18"></vue-feather>
                  </v-btn>
                </v-list-item-avatar>
              </template>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn>
    </div>
  </v-app-bar>
</template>
